"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
function resultIsError(value) {
    if (!value)
        return true;
    if (value == true)
        return false;
    return true;
}
/**Determina si un resultado de validación tiene errores */
async function hasError(validation) {
    //TODO: Arreglar firma de promiseAllObj
    const val = await keautils_1.promiseAllObj(validation);
    const ret = keautils_1.any(keautils_1.enumObject(val), x => x.value != null);
    return ret;
}
exports.hasError = hasError;
/**Evalua un conjunto de reglas de validación dado un objeto */
function getErrors(rules, value) {
    const result = keautils_1.pipe(rules, curr => keautils_1.mapObject(curr, (prop, key) => prop ? prop(value, key) : true), curr => keautils_1.mapObject(curr, async (prop) => {
        const pVal = await prop;
        return !(pVal) ? "error" : //Si prop evalua a falso, es error
            (pVal) === true ? undefined : //Si prop === true, no es error
                (pVal);
    }));
    return result;
}
exports.getErrors = getErrors;
/**Devuelve la cadena "Valor requerido" si value es null o undefined o cadena vacia, si no devuelve true*/
function required(value, key) {
    const val = (value && value[key]);
    return (val == null || val === "") ? "Obligatorio" : true;
}
exports.required = required;
/**Regla que verifica que el valor este adentro de un rango inclusivo. Es decir los valores exactamente iguales al minimo y máximo estan permitidos*/
function range(min, max) {
    return function (value, key) {
        if (value == null)
            return true;
        const val = value && value[key];
        if (min != null && val < min) {
            return "Debe de ser mayor o igual que " + min;
        }
        if (max != null && val > max) {
            return "Debe de ser menor o igual que " + max;
        }
        return true;
    };
}
exports.range = range;
/**Regla que verifica que el valor este adentro de un rango exclusivo. Es decir los valores exactamente iguales al minimo y máximo no estan permitidos*/
function rangeEx(min, max) {
    return function (value, key) {
        if (value == null)
            return true;
        const val = value && value[key];
        if (min && val <= min) {
            return "Debe de ser mayor que " + min;
        }
        if (max && val > max) {
            return "Debe de ser menor que " + max;
        }
        return true;
    };
}
exports.rangeEx = rangeEx;
/**Regla que verifica que un valor seea entero */
function integer(value, key) {
    if (value == null)
        return true;
    const val = value && value[key];
    if (typeof val != "number")
        return true;
    if (val != Math.floor(val)) {
        return "Debe de ser entero";
    }
    return true;
}
exports.integer = integer;
/**Regla que verifica la longitud de una cadena, el rango es inclusivo */
function length(min, max) {
    return function (value, key) {
        const len = keautils_1.nullsafe(value, x => x[key], x => x.length);
        if (len == null) {
            return true;
        }
        else {
            if (min != null && min == max && len != min) {
                //Longitud igual a 
                return `Debe de tener ${min} caracteres`;
            }
            else if (min != null && len < min) {
                return `Debe de tener por lo menos ${min} caracteres`;
            }
            else if (max != null && len < max) {
                return `Debe de tener hasta ${max} caracteres`;
            }
        }
    };
}
exports.length = length;
/**
 * Convierte una funcion que valida un @see TChild a una regla que puede formar parte de las validaciones de un @see TParent
 */
function subrule(validate) {
    return async (x, key) => {
        const val = x[key];
        const valResult = validate(val);
        if (await hasError(valResult)) {
            return "Inválido";
        }
        else {
            return true;
        }
    };
}
exports.subrule = subrule;
/**
 * Devuelve un nuevo conjunto de reglas el cual sólo valida a errores cuando se cumple la condición, es decir, si la condición no se cumple, el nuevo conjunto de reglas no devuelve errores
 * @param rules Conjunto de reglas base
 * @param condition Condición tal que sólo permitirá devulver errores si es true
 */
function when(condition, rules) {
    if (condition === true) {
        return rules;
    }
    else if (condition === false) {
        return {};
    }
    else {
        return keautils_1.mapObject(rules, (rule) => rule && ((value, key) => condition(value) ? rule(value, key) : true));
    }
}
exports.when = when;
function resultAndSync(a, b) {
    if (a === true && b === true)
        return true;
    if (typeof a == "string" && typeof b == "string")
        return a + ", " + b;
    if (typeof a == "string")
        return a;
    if (typeof b == "string")
        return b;
    else
        return a || b;
}
function resultAnd(a, b) {
    if (!keautils_1.isPromiseLike(a) && !keautils_1.isPromiseLike(b)) {
        return resultAndSync(a, b);
    }
    return (async () => {
        const aProm = Promise.resolve(a);
        const bProm = Promise.resolve(b);
        const race = await Promise.race([aProm, bProm]);
        if (resultIsError(race))
            return race;
        else
            return resultAnd(await aProm, await bProm);
    })();
}
exports.resultAnd = resultAnd;
/**Aplica un AND entre reglas, de tal manera que pasa solo si ninguna regla tiene rror */
function and2(a, b) {
    return async (value, key) => {
        return resultAnd(a(value, key), b(value, key));
    };
}
/**Aplica un AND entre reglas de tal manera que su solo una lanza error, la regla resultante reporta ese error */
function and(...rules) {
    return rules.reduce(and2);
}
exports.and = and;
/**
 * Devuelve un nuevo conjunto de reglas que es el AND entre dos conjuntos de reglas
 * @param a
 * @param b
 */
function andRules2(a, b) {
    const keys = keautils_1.union(Object.keys(a), Object.keys(b));
    const values = keautils_1.arrayToMap(keys.map((key) => {
        const aRule = a[key];
        const bRule = b[key];
        const value = aRule && bRule ? and2(aRule, bRule) :
            aRule || bRule;
        return { key, value };
    }));
    return values;
}
/**
 * Devuelve un nuevo conjunto de reglas que es el AND entre dos conjuntos de reglas
 */
function andRules(...rules) {
    return rules.reduce(andRules2);
}
exports.andRules = andRules;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/validation.js
// module id = 2265
// module chunks = 0